export default __webpack_public_path__ + "graphics/apple--white.84bc8b32.svg";